import { createContext } from 'react'

export const CurrencyContext = createContext([{}, () => {}])
export const UserContext = createContext([{}, () => {}])

export const UserProfileContext = createContext([{}, () => {}])
export const ClevertapDataContext = createContext([{}, () => {}])
export const OfferDataContext = createContext([{}, () => {}])
export const ProfileDataContext = createContext([{}, () => {}])
